import React from 'react';
import { PopupMenuListItem } from 'shared/components/ui/popup-menu';

import * as Styled from './quick-action-row.style';

export type QuickActionRowProps = {
  label: string;
  shortcut?: string;
  children: React.ReactNode;
};

export const QuickActionRow: React.FC<QuickActionRowProps> = ({
  label,
  shortcut,
  children,
}) => (
  <PopupMenuListItem>
    <Styled.Header>
      <Styled.HeaderLabel variant="body2">{label}</Styled.HeaderLabel>
      {!!shortcut && (
        <Styled.HeaderShortcut variant="overline">
          {shortcut}
        </Styled.HeaderShortcut>
      )}
    </Styled.Header>
    <Styled.ButtonContainer>{children}</Styled.ButtonContainer>
  </PopupMenuListItem>
);
